export enum ProductType {
    CONSUMABLE_PRODUCT = 'consumable_product',
    STORABLE_PRODUCT = 'storable_product'
}
